import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'zoom', 'Zoom', [["path",{"d":"M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"}],["path",{"d":"M21 21l-6 -6"}]]);